import { Check } from 'lucide-react';

export function SwitcherActiveFlag() {
  return (
    <div className="flex items-center gap-1.5 ml-auto text-xs text-accent-foreground">
      <span>Active</span>
      <Check className="h-3 w-3" />
    </div>
  );
}
